import { render, staticRenderFns } from "./financeiro-regras-profissional.vue?vue&type=template&id=2bf36214"
import script from "./financeiro-regras-profissional.vue?vue&type=script&lang=ts"
export * from "./financeiro-regras-profissional.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-regras-profissional.vue?vue&type=style&index=0&id=2bf36214&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports